/**
 * request 网络请求工具
 * 更详细的 api 文档: https://github.com/umijs/umi-request
 */
import { extend, RequestOptionsInit } from 'umi-request';
import { tokenStorage ,tokenStorageString} from '../utils/localStorageUtils';


// export const API_ROOT_URL = "http://192.168.2.201:5555/api";
// export const API_ROOT_URL = "http://localhost:5555/api";
// export const API_ROOT_URL = "http://192.168.0.111:5555/api";
// export const API_ROOT_URL = "http://8.131.237.161:5555/api";
// let API_ROOT_TEST = "https://api2test.hjiuye.com";
//  let API_ROOT_URL = "https://api.hjiuye.com";
//  if (location.host.indexOf("m2.hjiuye.com") >= 0) {
//     API_ROOT_URL = "https://api2test.hjiuye.com"
//   } else if (location.host.indexOf("m.hjiuye.com") >= 0) {
//     API_ROOT_URL = "https://api.hjiuye.com"
//   }
const API_ROOT_URL = "https://api.hjiuye.com"
const codeMessage: any = {
    200: '服务器成功返回请求的数据。',
    201: '新建或修改数据成功。',
    202: '一个请求已经进入后台排队（异步任务）。',
    204: '删除数据成功。',
    400: '发出的请求有错误，服务器没有进行新建或修改数据的操作。',
    401: '用户没有权限（令牌、用户名、密码错误）。',
    403: '用户得到授权，但是访问是被禁止的。',
    404: '发出的请求针对的是不存在的记录，服务器没有进行操作。',
    406: '请求的格式不可得。',
    410: '请求的资源被永久删除，且不会再得到的。',
    422: '当创建一个对象时，发生一个验证错误。',
    500: '服务器发生错误，请检查服务器。',
    502: '网关错误。',
    503: '服务不可用，服务器暂时过载或维护。',
    504: '网关超时。',
};

/**
 * 异常处理程序
 */
const errorHandler = (error: { response: Response }): Response => {
    const { response } = error;
    if (response && response.status) {
        const errorText = codeMessage[response.status] || response.statusText;
        const { status, url } = response;

        // notification.error({
        //     message: `请求错误 ${status}: ${url}`,
        //     description: errorText,
        // });

        console.error(`请求错误 ${status}: ${url}`);

        //token 错误
        if (response.status === 401) {

            // localStorage.removeItem("token");
            // localStorage.removeItem("antd-pro-authority");
            // window.location.href = "/user/login"
        }
    } else if (!response) {
        //  notification.error({
        //      description: '您的网络发生异常，无法连接服务器',
        //      message: '网络异常',
        //  });
    }
    return response;
};

/**
 * 配置request请求时的默认参数
 */
const request = extend({
    errorHandler, // 默认错误处理
    // credentials: 'include', // 默认请求是否带上cookie
});

export function Get(url: string, params: object = {}, token = false) {
    if (!url.startsWith("http:") && !url.startsWith("https:")) {
        url = API_ROOT_URL + url;
    }
    const options: RequestOptionsInit = {
        method: "get",
        responseType: "json",
        params
    }
    if (token) {
        options.headers = {
            'Authorization': "Bearer " + tokenStorage.get()?.value
        }
    }
    return request(url, options);
}
export function requstGet(url: string, params: object = {}, token = false) {
    if (!url.startsWith("http:") && !url.startsWith("https:")) {
        url = API_ROOT_URL + url;
    }
    const options: RequestOptionsInit = {
        method: "get",
        responseType: "json",
        params
    }
    if (token) {
        options.headers = {
            'Authorization': "Bearer " + tokenStorageString.get()
        }
    }
    return request(url, options);
}


export function Post(url: string, data: object = {}, params: object = {}, token = false) {
    if (!url.startsWith("http:") && !url.startsWith("https:")) {
        url = API_ROOT_URL + url;
    }
    const options: RequestOptionsInit = {
        method: "post",
        responseType: "json",
        data: data,
        params: params
    }
    if (token) {
        options.headers = {
            'Authorization': "Bearer " + tokenStorage.get()?.value
        }
    }
    return request(url, options);
}
export function requestPost(url: string, data: object = {}, params: object = {}, token = false) {
    if (!url.startsWith("http:") && !url.startsWith("https:")) {
        url = API_ROOT_URL + url;
    }
    const options: RequestOptionsInit = {
        method: "post",
        responseType: "json",
        data: data,
        params: params
    }
    if (token) {
        options.headers = {
            'Authorization': "Bearer " + tokenStorageString.get()
        }
    }
    return request(url, options);
}


export default { Get,requstGet, Post,requestPost };
